import gql from 'graphql-tag';
import graphqlClient from '../helpers/graphqlClient';

const messageFragment = gql`
	fragment message on MessageObjectGraphType {
		id
		text
		dateCreated
		messageStatus
		sentByStudent {
			firstName
			lastName
		}
		sentByUser {
			firstName
			lastName
		}
	}
`;

export default new (class {
	async getAll(skip, take, userID, facilityID) {
		const { data } = await graphqlClient.query({
			query: gql`
      {
        messages: messages(
          facilityid: ${facilityID}
          where: "ReceivedByUser.Id=${userID}"
          take: ${take}
          skip: ${skip}
          ) {
            receivedByUser {
              id
            }
            ...message
          }
					allReceivedMessages: messages(
            facilityid: ${facilityID}
            where: "ReceivedByUserId=${userID}"
            ) {
              receivedByUser {
                id
              }
            }
          }
				${messageFragment}
			`,

			fetchPolicy: 'no-cache'
		});

		return data;
	}

	async getAllUnread(skip, take, userID, facilityID) {
		const { data } = await graphqlClient.query({
			query: gql`
                {
					unreadMessages: messages(
						facilityid: ${facilityID}
						where: "ReceivedByUser.Id=${userID} && messageStatus=\\"Unread\\""
						take: ${take}
						skip: ${skip}
					) {
						receivedByUser {
							id
						}
						...message
					}
					
					allUnreadReceivedMessages: messages(
						facilityid: ${facilityID}
						where: "ReceivedByUser.Id=${userID} && messageStatus=\\"Unread\\" "
					) {
						receivedByUser {
							id
						}
						
					}
				}
				${messageFragment}
			`,

			fetchPolicy: 'no-cache'
		});

		return data;
	}

	async send(userID, message) {
		return await graphqlClient.mutate({
			mutation: gql`
				mutation($add: MessageAddInputObjectGraphType!) {
					addMessage(add: $add) {
						id
					}
				}
			`,
			variables: {
				add: {
					text: message,
					messageStatus: 'Unread',
					sentByUserId: userID
				}
			}
		});
	}

	async getPredefinedMessages() {
		const { data } = await graphqlClient.query({
			query: gql`
				{
					predefinedMessages {
						text
						roleId
						order
					}
				}
			`
		});

		return data.predefinedMessages;
	}
})();
